import React, { useRef, useState, useEffect } from "react";
import { sponsorRegistration } from "../../../../../core/data/json/contractFarming";
import CommonSelect from "./commonSelect";
import { DistrictOptionsAPMC } from "../../../../../core/data/json/apmc";
import { set } from "lodash";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { getOneContractFarmingDetails, approveRejectContactFarming, submitContractFarmingFiles, getAllSpices } from "../../../../auth/services/privateapicalling";
import { useNavigate } from "react-router";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { ItemsSponsor } from "../../../../../core/data/json/contractFarming";
import { Link } from "react-router-dom";
import Select from "react-select";
import DocView from "./DocView";

const MDFormL = ({
    applicationId
}) => {
  const token = useSelector((state: any) => state.auth.token);
  const [date, setDate] = useState("");
  const [applicationDataInfo, setApplicationDataInfo] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    applicationNo:"",
    applicationDate:"",
    registrationNo:"",
    // registrationDate:"",
    registrationPeriodFrom:"",
    registrationPeriodTo:"",
    districts:[],
    dateOfReceipt: new Date().toISOString().split('T')[0], // default to today
    Place:"Gandhinagar",
    rejectionFile: null as any,
    solvencyCertificate: null as any,
    bankGuarantee: null as any,
    firmNgoCoopCoopDetails: null as any,
    challanCopy: null as any,
    licenseProof: null as any,
  });

  const statusLevels = []

  const [district, setDistrict] = useState([]);
  
  const [isDisabled, setIsDisabled] = useState(true);
  const [iscommentOpen, setIscommentOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [changedFields, setChangedFields] = useState<any>({});
  const [hasChanges, setHasChanges] = useState(false);
  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const roleIdentifier = userDetail?.Role?.Role_Identifier;
  const[resubmit,setResubmit]=useState<any>();
  const [organizationType, setOrganizationType] = useState("");
  const organizationTypeOptions = [
  { value: "Company", label: "Company" },
  { value: "Partnership Firm", label: "Partnership Firm" },
  { value: "Non-Governmental Organization", label: "Non-Governmental Organization" },
  { value: "Co-operative Society", label: "Co-operative Society" },
  { value: "Government Organization", label: "Government Organization" }
];
  const [documentUpdateTrigger, setDocumentUpdateTrigger] = useState(0);
  
  // Modal states
const [showApproveModal, setShowApproveModal] = useState(false);
const [showApproveSuccessModal, setShowApproveSuccessModal] = useState(false);
const [showRaiseQueryModal, setShowRaiseQueryModal] = useState(false);
const [showRaiseQuerySuccessModal, setShowRaiseQuerySuccessModal] = useState(false);
const [showRejectModal, setShowRejectModal] = useState(false);
const [showRejectSuccessModal, setShowRejectSuccessModal] = useState(false);
// const [newlyUploaded, setNewlyUploaded] = useState<{[key: string]: string}>({});
// const [uploadLoading, setUploadLoading] = useState(false)
const [selectedIngredients, setSelectedIngredients] = useState<any[]>([]);
const [newlyUploaded, setNewlyUploaded] = useState<{[key: string]: string}>({});
const [uploadLoading, setUploadLoading] = useState(false);
const [spicesOptions, setSpicesOptions] = useState([]);

  const navigate = useNavigate();
  const formRef = useRef<HTMLDivElement>(null);



  // Fetch application data
  const fetchApplicationData = async (applicationId: string) => {
    try {
      setLoading(true);
      const result = await getOneContractFarmingDetails(applicationId, token);

      if (result.success && result.data) {
        setApplicationDataInfo(result.data);
        populateFormData(result.data);
      } else {
        toast.warning("No previous data found", { position: "top-right" });
      }
    } catch (error) {
    
      toast.error("Failed to load application data", { position: "top-right" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  getAllSpices(token)
    .then((data) => {
      const formatted = data.data.map((item) => ({
        value: item.id,
        label: item.Spices,
      }));
      setSpicesOptions(formatted);
    })
    .catch();
}, []);

  // Populate form with API data
  const populateFormData = (apiData: any) => {
    if (!apiData) return;

    // Base form data (YOU NEED THIS - IT WAS COMMENTED OUT)
    const baseData = {
      applicationNo: apiData?.Application_No || "",
      applicationDate: apiData?.createdAt?.split('T')[0] || "",
      registrationNo: apiData?.Sponsor_Registration_No || "",
      registrationPeriodFrom: apiData?.pendingAtMBA?.reSubmittedFields?.Sponsor_Reg_From?.currentValue || apiData?.Sponsor_Reg_From?.split('T')[0] || "",
      registrationPeriodTo: apiData?.pendingAtMBA?.reSubmittedFields?.Sponsor_Reg_To?.currentValue || apiData?.Sponsor_Reg_To?.split('T')[0] || "",
      districts: apiData?.commodityRegsBySponsorRegNo?.map((c: any) => c.district_id) || [],
      dateOfReceipt: apiData?.Date || new Date().toISOString().split('T')[0],
      Place: apiData?.Place || "Gandhinagar",
      rejectionFile: null,
    };

    // Document data
    if (apiData.uploadedDoc) {
      const docs = apiData.uploadedDoc;
      const docFields = {
        solvencyCertificate: docs.solvencyCertificate?.data || null,
        bankGuarantee: docs.bankGuarantee?.data || null,
        firmNgoCoopCoopDetails: docs.firmNgoCoopCoopDetails?.data || null,
        challanCopy: docs.challanCopy?.data || null,
        licenseProof: docs.licenseProof?.data || null,
      };

      // Combine base data and document data
      setFormData((prev) => ({
        ...prev,
        ...baseData,
        ...docFields,
      }));

      if (docs.firmNgoCoopCoopDetails?.data?.documentName) {
  const docName = docs.firmNgoCoopCoopDetails.data.documentName;
  
  // Check if it's a valid organization type
  const isValidOrgType = organizationTypeOptions.some(opt => opt.value === docName);
  
  if (isValidOrgType) {
    setOrganizationType(docName);
  } else if (docName !== "firmNgoCoopCoopDetails") {
    // It might be a custom value
    setOrganizationType(docName);
  }
}

    } else {
      // Only base data if no documents
      setFormData((prev) => ({
        ...prev,
        ...baseData,
      }));
    }

    // Populate ingredients
    if (apiData?.Det_Agriculture_Prod) {
      const ingredients = apiData.Det_Agriculture_Prod.split(", ").map(
        (item) => ({
          label: item,
          value: item,
        })
      );
      setSelectedIngredients(ingredients);
    }
  };

  useEffect(() => {
    if (applicationId) {
      fetchApplicationData(applicationId);
    }
  }, [applicationId]);

  // Function to calculate text width and adjust input width
  const adjustInputWidth = (text: string, minWidth: number = 200) => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (context) {
      context.font = '1.25rem Arial';
      const textWidth = context.measureText(text).width;
      return Math.max(minWidth, textWidth + 20);
    }
    return minWidth;
  };

  const editHandler = () => {
    if(isDisabled){
        setIsDisabled(false);
        setChangedFields({});
        setHasChanges(false);
        toast.success("You Can Edit the Form",{position:"top-right"})
    } else {
        setIsDisabled(true);
        toast.warning("Form Disabled",{position:"top-right"})
    }
  }



  const handleInputChange = (field: string, value: string) => {
    // Validation for date fields
    if (field === 'Sponsor_Reg_From' || field === 'Sponsor_Reg_To') {
      const fromDate = field === 'Sponsor_Reg_From' 
        ? value 
        : (resubmit?.Sponsor_Reg_From ?? formData.registrationPeriodFrom);
      
      const toDate = field === 'Sponsor_Reg_To' 
        ? value 
        : (resubmit?.Sponsor_Reg_To ?? formData.registrationPeriodTo);

      // Check if from date is greater than to date
      if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
        toast.error("Registration 'From' date cannot be greater than 'To' date", { 
          position: "top-right" 
        });
        return; // Don't update the state
      }
    }

    setResubmit(prev => ({
      ...prev,
      [field]: value
    }));
    

    // Input for Date and Place
    if (field === 'dateOfReceipt' || field === 'Place') {
      setFormData(prev => ({
        ...prev,
        [field]: value
      }));
    }
    
   
  };

// Unified handler for all actions (Approve/Raise Query/Reject)
const handleAction = async (actionType: 'approve' | 'raiseQuery' | 'reject') => {
  // Validate date and place
  if (!formData.dateOfReceipt) {
    toast.error("Please select a date", { position: "top-right" });
    return;
  }

  if (!formData.Place || formData.Place.trim() === "") {
    toast.error("Please enter a place", { position: "top-right" });
    return;
  }

  // Validate comment before submission
  if (!comment || comment.trim() === "") {
    toast.error("Please enter remarks before proceeding", { position: "top-right" });
    return;
  }

  try {
    const submittedFields: any = { ...resubmit };
    
    // Handle document fields with proper array/object checking
    const docFields = [
      'solvencyCertificate',
      'bankGuarantee',
      'firmNgoCoopCoopDetails',
      'challanCopy',
      'licenseProof'
    ];
    
    // ✅ FIX: Check if document exists before processing
    docFields.forEach(field => {
      // Check if there's a newly uploaded document in resubmit
      if (resubmit?.[field]?.data?.[0]?.docId) {
        submittedFields[field] = {
          type: 'document',
          data: [resubmit[field].data[0]]
        };
      } 
      // Check if document exists in formData (could be array or object)
      else if (formData?.[field]) {
        const docData = Array.isArray(formData[field]) 
          ? formData[field][0] 
          : formData[field];
        
        if (docData?.docId) {
          submittedFields[field] = {
            type: 'document',
            data: [{
              docId: docData.docId,
              documentName: docData.documentName || field,
              fileName: docData.fileName || docData.documentName || ''
            }]
          };
        }
      }
    });
    
    // Handle rejection file only for reject action
    if (actionType === 'reject') {
      if (resubmit?.rejectionFile?.data?.[0]?.docId) {
        submittedFields.rejectionFile = {
          type: 'document',
          data: [resubmit.rejectionFile.data[0]]
        };
      } else if (formData?.rejectionFile?.docId) {
        submittedFields.rejectionFile = {
          type: 'document',
          data: {
            docId: formData.rejectionFile.docId,
            documentName: 'rejectionFile',
            fileName: formData.rejectionFile.fileName
          }
        };
      }
    }
    
    // Determine which button to use based on action type
    const buttonIndex = actionType === 'approve' ? 0 : actionType === 'raiseQuery' ? 1 : 2;
    
    const payload = {
      applicationId: applicationId,
      status: applicationDataInfo?.buttonName[buttonIndex]?.status,
      appStatusLevel: applicationDataInfo?.buttonName[buttonIndex]?.appStatusLevel,
      comment: comment,
      submittedFields: submittedFields,
      date: formData.dateOfReceipt,
      place: formData.Place,
    };
    
    const response = await approveRejectContactFarming(payload, token);
    
    if (response.success) {
      // Close appropriate modal and show success modal
      if (actionType === 'approve') {
        setShowApproveModal(false);
        setShowApproveSuccessModal(true);
        toast.success("Application Approved Successfully", { position: "top-right" });
      } else if (actionType === 'raiseQuery') {
        setShowRaiseQueryModal(false);
        setShowRaiseQuerySuccessModal(true);
        toast.success("Query raised successfully", { position: "top-right" });
      } else {
        setShowRejectModal(false);
        setShowRejectSuccessModal(true);
        toast.success("Application rejected successfully", { position: "top-right" });
      }
      
      // Clear state
      setChangedFields({});
      setHasChanges(false);
      setIsDisabled(true);
      setComment("");
      setNewlyUploaded({});
      fetchApplicationData(applicationId);
      
      // Navigate after success modal
      setTimeout(() => {
        navigate("/marketing-board-reg-menu");
      }, 1000);
    }
  } catch (error) {
   
    toast.error(`Failed to ${actionType} application`, { position: "top-right" });
  }
};

// Button click handlers
const handleApprove = () => handleAction('approve');
const handleRaiseQuery = () => handleAction('raiseQuery');
const handleReject = () => handleAction('reject');


      useEffect(() => {
        if (
          applicationDataInfo &&
          Array.isArray(applicationDataInfo?.commodityRegsBySponsorRegNo) &&
          applicationDataInfo?.commodityRegsBySponsorRegNo.length > 0
        ) {
          type Commodity = {
            district_id: string;
            departmentDetailsByApmc?: { District?: string };
          };
    
          const commodities: Commodity[] = applicationDataInfo?.commodityRegsBySponsorRegNo;
         
    
          const uniqueDistricts = Array.from(
            new Set(commodities.map((c: Commodity) => c.district_id))
          );
          
    
          const districtData = uniqueDistricts.map((distId) => {
            const commodity = commodities.find((c: Commodity) => c.district_id === distId);
            return {
              value: distId,
              label: commodity?.departmentDetailsByApmc?.District || "",
            };
          });
          setDistrict(districtData);
       
        }
      }, [applicationDataInfo]);

      // Handle Download Form L as PDF
const handleDownloadFormL = async () => {
  if (!formRef.current) return;

  try {
    toast.info("Generating PDF...", { position: "top-right" });

    // Hide buttons and edit controls before capture
    const editButton = document.querySelector('.edit-button-container');
    const actionButtons = document.querySelector('.action-buttons-container');
    const downloadButton = document.querySelector('.download-button-container');
    if (editButton) (editButton as HTMLElement).style.display = 'none';
    if (actionButtons) (actionButtons as HTMLElement).style.display = 'none';
    if (downloadButton) (downloadButton as HTMLElement).style.display = 'none';

    // Replace all inputs with spans containing their values
    const allInputs = formRef.current.querySelectorAll('input:not([type="file"]), textarea, select');
    const replacedElements: { original: HTMLElement; replacement: HTMLElement; parent: HTMLElement }[] = [];
    
    allInputs.forEach((input) => {
      const htmlInput = input as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
      const value = htmlInput.value || '';
      
      // Create a span element with the input's value
      const span = document.createElement('span');
      span.textContent = value;
      span.style.fontSize = window.getComputedStyle(htmlInput).fontSize;
      span.style.color = window.getComputedStyle(htmlInput).color;
      span.style.fontFamily = window.getComputedStyle(htmlInput).fontFamily;
      span.style.display = 'inline';
      span.style.marginLeft = '0.25rem';
      span.style.marginRight = '0.25rem';
      
      // Store original element and its parent
      const parent = htmlInput.parentElement;
      if (parent) {
        replacedElements.push({
          original: htmlInput as HTMLElement,
          replacement: span,
          parent: parent as HTMLElement
        });
        
        // Replace input with span
        parent.replaceChild(span, htmlInput);
      }
    });



    // Hide file input completely
    const fileInputs = formRef.current.querySelectorAll('input[type="file"]');
    const fileInputParents: HTMLElement[] = [];
    fileInputs.forEach((input) => {
      const parent = input.parentElement;
      if (parent) {
        fileInputParents.push(parent as HTMLElement);
        (parent as HTMLElement).style.display = 'none';
      }
    });

    // Capture the form content
    const canvas = await html2canvas(formRef.current, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff'
    });

    // Restore all original inputs
    replacedElements.forEach(({ original, replacement, parent }) => {
      parent.replaceChild(original, replacement);
    });

    // Restore file input parents
    fileInputParents.forEach((parent) => {
      parent.style.display = '';
    });

    // Show buttons again
    if (editButton) (editButton as HTMLElement).style.display = 'flex';
    if (actionButtons) (actionButtons as HTMLElement).style.display = 'flex';
    if (downloadButton) (downloadButton as HTMLElement).style.display = 'flex';

    const imgData = canvas.toDataURL("image/jpeg");
    
    // Create PDF
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4'
    });

    const imgWidth = 210;
    const pageHeight = 297;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    // Add first page
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // Add additional pages if content is longer than one page
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    // Save the PDF
    pdf.save(`Form_L_${applicationId}_${new Date().toISOString().split('T')[0]}.pdf`);
    
    toast.success("Form L downloaded successfully!", { position: "top-right" });
  } catch (error) {
  
    toast.error("Failed to download Form L", { position: "top-right" });
  }
};

    //Rejection Doc Upload
const handleFileChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  fieldName: string
) => {
  const { files } = e.target;
  if (files && files.length > 0) {
    const file = files[0];
    const fileName = file.name;
    handleUpload(fileName, file, fieldName, formData[fieldName]?.docId);
  }
};

const handleUpload = async (
  documentName: string,
  file: any,
  fieldName: string,
  docId?: string | null
) => {
  const uploadFormData = new FormData();
  uploadFormData.append("file", file);
  uploadFormData.append("documentName", fieldName);
  uploadFormData.append("fieldName", fieldName);
  uploadFormData.append("applicationId", applicationId);

  try {
    setUploadLoading(true);
    const res = await submitContractFarmingFiles(
      uploadFormData,
      token,
      docId
    );

    if (res.success === false) {
      toast.error(res?.message, { position: "top-right" });
    } else if (res.success && res.docId) {
      const data = {
        docId: res.docId,
        documentName: fieldName,
        fileName: documentName,
      };
      
      setResubmit((prev) => ({
        ...prev,
        [fieldName]: {
          type: 'document',
          data: [data]
        },
      }));
      
      setNewlyUploaded((prev) => ({
        ...prev,
        [fieldName]: documentName
      }));

       setFormData((prev) => ({
        ...prev,
        [fieldName]: [data] // Store as array to match API structure
      }));
      
      setChangedFields((prev) => ({
        ...prev,
        [fieldName]: {
          data: {
            docId: res.docId,
            documentName: fieldName,
          }
        },
      }));
      
      setHasChanges(true);
      toast.success(res?.message, { position: "top-right" });
      setDocumentUpdateTrigger(prev => prev + 1);

    }
  } catch (error) {
    toast.error("File upload failed", { position: "top-right" });
  } finally {
    setUploadLoading(false);
  }
};

const handleIngredientsChange = (selected: any) => {
  setSelectedIngredients(selected);
  setChangedFields((prev) => ({
    ...prev,
    Det_Agriculture_Prod: selected.map((item: any) => item.label).join(", "),
  }));
  setHasChanges(true);
};

    const getFieldColorClass = (apiField: string, formDataField: string) => {
  // Only show colors for MBA and MBMD roles
  if (roleIdentifier !== "MBA" && roleIdentifier !== "MBMD") return "";
  
  const resubmitValue = resubmit?.[apiField];
  const formValue = formData[formDataField];
  const status = applicationDataInfo?.status;
  
  // Determine which transaction field to check based on status and role
  let pendingField = null;
  
  // Check if we're in a resubmission cycle (second cycle onwards)
  const isResubmissionCycle = status === "resubmission";
  
  if (isResubmissionCycle) {
    // Second cycle onwards: Check resubmission fields
    if (roleIdentifier === "MBMD") {
      // MBMD sees changes from MBA Resubmission
      pendingField = applicationDataInfo?.transaction?.pendingAtMBAResubmission?.reSubmittedFields?.[apiField];
    } else if (roleIdentifier === "MBA") {
      // MBA makes changes but doesn't see colors during resubmission
      return "";
    }
  } else {
    // First cycle: Check original pending fields
    if (roleIdentifier === "MBMD") {
      // MBMD sees changes from MBA
      pendingField = applicationDataInfo?.transaction?.pendingAtMBA?.reSubmittedFields?.[apiField];
    } else if (roleIdentifier === "MBA") {
      // MBA makes changes but doesn't see colors in first cycle
      return "";
    }
  }
  
  // Green: User just edited this field in current session (both MBA and MBMD)
  if (resubmitValue && resubmitValue !== formValue) {
    return "text-success";
  } 
  
  // Yellow/Warning: Field was previously submitted AND values are different
  if (pendingField) {
    // Handle object format with previousValue/currentValue
    if (typeof pendingField === 'object' && pendingField !== null) {
      if ('previousValue' in pendingField && 'currentValue' in pendingField) {
        if (pendingField.previousValue !== pendingField.currentValue) {
          return "text-warning";
        }
      }
    }
    // Handle simple value format (like document fields)
    else if (pendingField) {
      return "text-warning";
    }
  }
  
  return "";
};  

  return(
    <div className="">
      {loading ? (
        <div className="text-center p-5">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <>
        {uploadLoading && (
  <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" 
       style={{background: "rgba(0,0,0,0.3)", zIndex: 1050}}>
    <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
      <div className="spinner-border text-primary mb-3" role="status">
        <span className="visually-hidden">Uploading...</span>
      </div>
      <div className="fw-bold">Uploading, please wait...</div>
    </div>
  </div>
)}
          {/* Edit Button */}
          <div className="w-100 mt-5 edit-button-container">
            {roleIdentifier === "MBMD" && (
              <div className="mx-5">
            <div className="d-flex justify-content-between">
              <div className="w-100">
                <p className="fw-bold" style={{fontSize:"1.4rem", wordWrap: "break-word", overflowWrap: "break-word"}}>
                  Comment from Marketing Board Administrator: <p className="fw-normal bg-white p-2 rounded border border-secondary" style={{fontSize:"1.2rem"}}>
                    {(applicationDataInfo?.transaction?.pendingAtMBAResubmission ? applicationDataInfo?.transaction?.pendingAtMBAResubmission?.comment: applicationDataInfo?.transaction?.pendingAtMBA?.comment) || "N/A"}
                    </p>
                </p>
              </div>

            </div>
             <div className="d-flex justify-content-between mt-5 align-items-center">
              <p style={{fontSize:"1.2rem"}} className="m-0 p-0 ">To Edit this form Click on Edit button</p>
               
              {isDisabled ? (
                <button
                onClick={editHandler}
                className="btn btn-outline-secondary position-relative end-0"
              >
                <i className="feather feather-edit"></i>
                {isDisabled ? "Edit" : "Lock"}
              </button>
              ):
              <div>Auto Saved</div>}
             </div>
              </div>
            )}
          </div>
          
          {/* Main Form */}
            <div ref={formRef} className="d-flex bg-white p-5 rounded flex-column m-5 text-nightblue justify-content-center text-black" style={{ fontSize: '1.25rem' }}>
            <div className="text-center ">
              <h3>[SEE RULE 119(2)]</h3>
              <h3>FORM - L</h3>
              <h3>[SEE RULE 119(2)]</h3>
              <h3>REGISTRATION OF CONTRACT FARMING SPONSOR</h3>
            </div>
            
            <div className="mb-4">
              <p style={{ fontSize: "1.25rem" }} className="text-black">
                To,
              </p>
              <h3 style={{ fontSize: "1.25rem" }} className="text-black mb-3">
                Managing Director
              </h3>
              <h3 style={{ fontSize: "1.25rem" }} className="text-black mb-3">
                Gujarat State Agriculture Marketing Board
              </h3>
              <h3 style={{ fontSize: "1.25rem" }} className="text-black">
                Gandhi Nagar
              </h3>
            </div>
            
            <div className="my-3">
              <p><span className="fw-bold">Sub:</span> Registration as Contract Farming Sponsor in the districts/ whole of the state.</p>
            </div>
            
            <div>
              <p style={{ fontSize: '1.25rem' }} className="text-black">Sir,</p>
              <p style={{ fontSize: '1.25rem' }} className="text-black">
                With refrence to your application No
                <input
                  className="text-center mx-1 border-0 my-1 border-bottom border-secondary "
                  style={{
                    width: `${adjustInputWidth(formData.applicationNo)}px`,
                    minWidth: '200px'
                  }}
                  disabled={true}
                  value={applicationId}
                  onChange={(e) => handleInputChange('applicationNo', e.target.value)}
                  placeholder="Application No."

                /> dated
                <input
                  type="date"
                  className="text-center border-0 border-bottom border-2 border-secondary rounded-0 mx-2"
                  style={{
                    width: `${adjustInputWidth(formData.applicationDate || 'mm/dd/yyyy')}px`,
                    minWidth: '200px',
                    color: formData.applicationDate ? "black" : "#6c757d"
                  }}
                  disabled={true}
                  value={resubmit?.Application_Date ?? formData?.applicationDate}
                  onChange={(e) => handleInputChange('Application_Date', e.target.value)}
                />on the above cited subject, you are informed that your application for Registration has been accepted.
                The Registration No. alloted to you is
                <input
                  className="text-center mx-1 my-1 border-0 border-bottom border-secondary "
                  style={{
                    width: `${adjustInputWidth(formData.registrationNo)}px`,
                    minWidth: '200px'
                  }}
                  disabled={true}
                  value={formData.registrationNo}
                  onChange={(e) => handleInputChange('registrationNo', e.target.value)}
                  placeholder="Registration No."
                />dated
                <input
                  type="date"
                  className="text-center border-0 border-bottom border-2 border-secondary rounded-0 m-2"
                  style={{
                    width: `${adjustInputWidth(formData.registrationPeriodFrom || 'mm/dd/yyyy')}px`,
                    minWidth: '200px',
                    color: formData.registrationPeriodFrom ? "black" : "#6c757d"
                  }}
                  disabled={true}
                  value={resubmit?.Sponsor_Reg_From ?? formData?.registrationPeriodFrom}
                  onChange={(e) => handleInputChange('Sponsor_Reg_From', e.target.value)}
                />
              </p>
              
              <p>
                The registeration is for the period from
                <input
                  type="date"
                      className={`text-center border-0 border-bottom border-2 border-secondary rounded-0 m-2 ${getFieldColorClass("Sponsor_Reg_From", "registrationPeriodFrom")}`}
                  style={{
                    width: `${adjustInputWidth(formData.registrationPeriodFrom || 'mm/dd/yyyy')}px`,
                    minWidth: '200px',
                    color: formData.registrationPeriodFrom ? "black" : "#6c757d"
                  }}
                  disabled={isDisabled}
                  value={resubmit?.Sponsor_Reg_From ?? formData.registrationPeriodFrom}
                  onChange={(e) => handleInputChange('Sponsor_Reg_From', e.target.value)}
                />
                to
               <input
                  type="date"
                      className={`text-center border-0 border-bottom border-2 border-secondary rounded-0 m-2 ${getFieldColorClass("Sponsor_Reg_To", "registrationPeriodTo")}`}
                  style={{
                    width: `${adjustInputWidth(formData.registrationPeriodTo || 'mm/dd/yyyy')}px`,
                    minWidth: '200px',
                    color: formData.registrationPeriodTo ? "black" : "#6c757d"
                  }}
                  disabled={isDisabled}
                  value={resubmit?.Sponsor_Reg_To ?? formData.registrationPeriodTo}
                  onChange={(e) => handleInputChange('Sponsor_Reg_To', e.target.value)}
                />
                for operating in the followning district of the State : 
                <div style={{ display: 'inline-block', minWidth: '200px' }} className="ps-2">
                  {district.map((dist, index) => (
                      <span key={dist.value}>
                        {dist.label}
                        {index < district.length - 1 && " ,"}
                      </span>
                    ))}
                </div>
              </p>
              
              <div className="border rounded">
                <p style={{ fontSize: '1.25rem' }} className="text-black p-3">The conditions of registration are given below:</p>
                <div className="d-flex bg-gray p-2 align-items-center justify-content-between mb-3" style={{ fontSize: "1.25rem", color: "black" }}>
                  <span className="w-100">(1) The registration holder shall comply with the provisions of the Act, rules and instructions issued in this behalf.</span>
                </div>
                <div className="d-flex p-2 align-items-center justify-content-between mb-3 " style={{ fontSize: "1.25rem", color: "black" }}>
                  <span className="w-100">(2) The registration holder shall comply with the terms and conditions of the contract.</span>
                </div>
              </div>

              {/* Documents Section */}

{roleIdentifier==="MBMD" && (
  <div className="border rounded mt-4">
  <p style={{ fontSize: "1.25rem" }} className="text-black p-3">
    Enclosed documents:
  </p>

  {/* Document 1: Solvency Certificate */}
  <div className="d-flex bg-gray p-2 align-items-center justify-content-between mb-3"
       style={{ fontSize: "1.25rem", color: "black" }}>
    <span className="w-75">(1) Solvency certificate</span>
    <div className="d-flex flex-column w-25 ms-3">
      <Link
        to="#"
        data-bs-toggle="modal"
        data-bs-target="#contract_farming_modal"
        className="btn btn-outline-info align-items-center w-100"
        data-doc-id={resubmit?.solvencyCertificate?.data?.[0]?.docId || formData?.solvencyCertificate?.docId}
      >
        <i className="ti ti-eye"></i> View Document
      </Link>
      {!isDisabled && (
        <input
          type="file"
          name="solvencyCertificate"
          onChange={(e) => handleFileChange(e, "solvencyCertificate")}
          accept=".pdf, .jpeg, .jpg"
          className="form-control w-100 mt-2"
          style={{ fontSize: "0.8rem" }}
        />
      )}
      {newlyUploaded.solvencyCertificate && (
        <p className="fs-15 mt-2 opacity-75 text-center">
          Uploaded: {newlyUploaded.solvencyCertificate}
        </p>
      )}
    </div>
  </div>

  {/* Document 2: Bank Guarantee */}
  <div className="d-flex bg-white p-2 align-items-center justify-content-between mb-3"
       style={{ fontSize: "1.25rem", color: "black" }}>
    <span className="w-75">(2) Bank Guarantee</span>
    <div className="d-flex flex-column w-25 ms-3">
      {(resubmit?.bankGuarantee?.data?.[0]?.docId || formData?.bankGuarantee?.docId) ? (
         <Link
        to="#"
        data-bs-toggle="modal"
        data-bs-target="#contract_farming_modal"
        className="btn btn-outline-info align-items-center w-100"
        data-doc-id={resubmit?.bankGuarantee?.data?.[0]?.docId || formData?.bankGuarantee?.docId}
      >
        <i className="ti ti-eye"></i> View Document
      </Link>
      ) : (<h5 className="text-center">No Document Available</h5>)}
     
      {!isDisabled && (
        <input
          type="file"
          name="bankGuarantee"
          onChange={(e) => handleFileChange(e, "bankGuarantee")}
          accept=".pdf, .jpeg, .jpg"
          className="form-control w-100 mt-2"
          style={{ fontSize: "0.8rem" }}
        />
      )}
      {newlyUploaded.bankGuarantee && (
        <p className="fs-15 mt-2 opacity-75 text-center">
          Uploaded: {newlyUploaded.bankGuarantee}
        </p>
      )}
    </div>
  </div>

  {/* Document 3: Registration Documents */}
 {/* Document 3: Registration Documents */}
<div className="d-flex bg-gray p-2 align-items-center justify-content-between mb-3"
     style={{ fontSize: "1.25rem", color: "black" }}>
  <span className="w-50">
    (3) Registration Documents of
    <div style={{ display: "inline-block", minWidth: "200px" }} className="ms-2">
      <Select
        options={organizationTypeOptions}
        value={organizationTypeOptions.find(opt => opt.value === organizationType)}
        placeholder="Organization Type"
        className="border-0"
        isDisabled={true}
        styles={{
          control: (base) => ({
            ...base,
            backgroundColor: "#ffffffff",
          }),
        }}
      />
    </div>and names and addresses of directors and partners, etc.
  </span>
  <div className="d-flex flex-column w-25 ms-3">
    <Link
      to="#"
      data-bs-toggle="modal"
      data-bs-target="#contract_farming_modal"
      className="btn btn-outline-info align-items-center w-100"
      data-doc-id={resubmit?.firmNgoCoopCoopDetails?.data?.[0]?.docId || formData?.firmNgoCoopCoopDetails?.docId}
    >
      <i className="ti ti-eye"></i> View Document
    </Link>
    {!isDisabled && (
      <input
        type="file"
        onChange={(e) => handleFileChange(e, "firmNgoCoopCoopDetails")}
        accept=".pdf, .jpeg, .jpg"
        name="firmNgoCoopCoopDetails"
        className="form-control mt-2"
        style={{ fontSize: "0.8rem" }}
      />
    )}
    {newlyUploaded.firmNgoCoopCoopDetails && (
      <p className="fs-15 mt-2 opacity-75 text-center">
        Uploaded: {newlyUploaded.firmNgoCoopCoopDetails}
      </p>
    )}
  </div>
</div>

  {/* Document 4: Agricultural Produce Details */}
  <div className="d-flex bg-white p-2 align-items-center justify-content-between mb-3"
       style={{ fontSize: "1.25rem", color: "black" }}>
    <span className="w-75">
      (4) Details of agricultural produce coming under the contract
    </span>
    <div className="w-25 ps-4 me-2">
      <Select
        isMulti
        options={ItemsSponsor.options}
        value={selectedIngredients}
        onChange={handleIngredientsChange}
        placeholder="Select Items"
        className="mx-2 w-100 border-0"
        isDisabled={true}
      />
    </div>
  </div>

  {/* Document 5: Challan Copy */}
  <div className="d-flex bg-gray p-2 align-items-center justify-content-between"
       style={{ fontSize: "1.25rem", color: "black" }}>
    <span className="w-75">
      (5) Copy of challan (fee payment proof)
    </span>
    <div className="d-flex flex-column w-25 ms-3">
      <Link
        to="#"
        data-bs-toggle="modal"
        data-bs-target="#contract_farming_modal"
        className="btn btn-outline-info align-items-center w-100"
        data-doc-id={resubmit?.challanCopy?.data?.[0]?.docId || formData?.challanCopy?.docId}
      >
        <i className="ti ti-eye"></i> View Document
      </Link>
      {!isDisabled && (
        <input
          type="file"
          name="challanCopy"
          onChange={(e) => handleFileChange(e, "challanCopy")}
          accept=".pdf, .jpeg, .jpg"
          className="form-control w-100 mt-2"
          style={{ fontSize: "0.8rem" }}
        />
      )}
      {newlyUploaded.challanCopy && (
        <p className="fs-15 mt-2 opacity-75 text-center">
          Uploaded: {newlyUploaded.challanCopy}
        </p>
      )}
    </div>
  </div>

  {/* Document 6: License Proof */}
  <div className="d-flex bg-white p-2 align-items-center justify-content-between mb-3"
       style={{ fontSize: "1.25rem", color: "black" }}>
    <span className="w-75">
      (6) Proof of manufacturing/processing/export-import licence
    </span>
    <div className="d-flex flex-column w-25 ms-3">
      <Link
        to="#"
        data-bs-toggle="modal"
        data-bs-target="#contract_farming_modal"
        className="btn btn-outline-info align-items-center w-100"
        data-doc-id={resubmit?.licenseProof?.data?.[0]?.docId || formData?.licenseProof?.docId}
      >
        <i className="ti ti-eye"></i> View Document
      </Link>
      {!isDisabled && (
        <input
          type="file"
          name="licenseProof"
          onChange={(e) => handleFileChange(e, "licenseProof")}
          accept=".pdf, .jpeg, .jpg"
          className="form-control mt-2"
          style={{ fontSize: "0.8rem" }}
        />
      )}
      {newlyUploaded.licenseProof && (
        <p className="fs-15 mt-2 opacity-75 text-center">
          Uploaded: {newlyUploaded.licenseProof}
        </p>
      )}
    </div>
  </div>
</div>
)}
              
              {roleIdentifier === "MBMD" ? (
                <div>
                <p style={{ fontSize: '1.25rem' }} className="text-black mt-4">Date:
                  <input
                    type="date"
                    className="border-0 border-bottom border-2 border-secondary mb-3 rounded-0 mx-2"
                    style={{
                      width: `${adjustInputWidth(formData.dateOfReceipt || 'mm/dd/yyyy')}px`,
                      minWidth: '200px',
                      color: formData.dateOfReceipt ? "black" : "#6c757d"
                    }}
                    value={formData.dateOfReceipt || new Date().toISOString().split('T')[0]}
                    onChange={(e) => handleInputChange('dateOfReceipt', e.target.value)}
                    disabled={true}
                  />
                </p>
                <p style={{ fontSize: '1.25rem' }} className="text-black mt-4">Place:
                  <input
                    className="mx-1 border-0 border-bottom border-secondary "
                    style={{
                      width: `${adjustInputWidth(formData.Place)}px`,
                      minWidth: '200px'
                    }}
                    // disabled={isDisabled}
                    value={formData.Place}
                    onChange={(e) => handleInputChange('Place', e.target.value)}
                    placeholder="Place"
                    disabled={true}
                  />
                </p>
              </div>
              ):(
                <div className="mt-4">
                  <p>Date: {resubmit?.Date_Of_Receipt ?? formData?.dateOfReceipt}</p>
                  <p>Place: {resubmit?.Place_Of_Receipt ?? formData?.Place}</p>
                </div>
              )}
              
              
              <div className="d-flex justify-content-end align-items-end flex-column ">
                {/* <input type="file"
                //  disabled={isDisabled}
                  className="form-control w-25 mt-4" /> */}
                <p style={{ fontSize: '1.25rem' }} className="text-black py-3 position-relative left-0">Signature of Applicant.</p>
              </div>
            </div>
          </div>
          
          {/* Action Buttons */}
        {roleIdentifier === "MBMD" && (
          <div className="d-flex justify-content-end mb-5 me-5 gap-3 pe-5 action-buttons-container">
            <button 
              className="btn btn-outline-secondary" 
              onClick={() => setShowRaiseQueryModal(true)}
            >
              Raise Query: Sent Back to Sponsor
            </button>
            <button 
              className="btn btn-outline-danger px-4" 
              onClick={() => setShowRejectModal(true)}
            >
              Reject
            </button>
            <button 
              className="btn btn-info px-4" 
              onClick={() => setShowApproveModal(true)}
            >
              Approve
            </button>
          </div>
        )}
          
          {/* Approve Modal */}
          <div className="col-xl-4">
            <div className="card-body">
              {showApproveModal && (
                <>
                  <div className="modal fade show" style={{display: 'block'}} id="approveModal" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabIndex={-1}>
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title" id="exampleModalToggleLabel">Application Confirmation</h4>
                      {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" /> */}
                      <button 
                        type="button" 
                        className="btn-close" 
                        onClick={() => setShowApproveModal(false)}
                        aria-label="Close" 
                      />
                    </div>
                    <div className="modal-body">
                      <p>Are you sure you want to approve this application. ?</p>
                      <textarea
                        className={`form-control w-100 ${comment.trim() === '' ? 'border-danger' : ''}`}
                        style={{ fontSize: '1.25rem' }}
                        rows={3}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder="Enter your remarks here. *"
                        required
                      />
                      {comment.trim() === '' && (
                        <small className="text-danger">* Remarks are required</small>
                      )}
                    </div>
                    <div className="modal-footer">
                      {/* <button type="button" className="btn btn-outline-secondary me-3" data-bs-dismiss="modal" aria-label="Close">Cancel</button> */}
                        <button 
                          type="button" 
                          className="btn btn-outline-secondary me-3" 
                          onClick={() => {
                            setShowApproveModal(false);
                        setComment("");
                      }}
                        >
                      Cancel
                    </button>
                      <button
                        className="btn btn-info"
                        onClick={handleApprove}
                      >Yes Approve</button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-backdrop fade show"></div>
            </>
        )}
          {showApproveSuccessModal && (
            <>
              <div className="modal fade" id="approveModal2" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2" tabIndex={-1}>
                <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title" id="exampleModalToggleLabel2">
                        <i className="feather feather-check-circle text-success me-2"></i>
                        Success
                      </h4>
                      {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" /> */}
                      <button 
                        type="button" 
                        className="btn-close" 
                        onClick={() => setShowApproveSuccessModal(false)}
                        aria-label="Close" 
                      />
                    </div>
                    <div className="modal-body">
                      Application approved successfully and sent to Sponsor.
                    </div>
                    <div className="modal-footer">
                      {/* <button type="button" className="btn btn-info me-3 w-100" data-bs-dismiss="modal" aria-label="Close" onClick={() => navigate("/marketing-board-reg-menu")}>Ok</button> */}
                      <button 
                        type="button" 
                        className="btn btn-info me-3 w-100" 
                        onClick={() => {
                          setShowApproveSuccessModal(false);
                          setTimeout(()=>{
                            navigate("/marketing-board-reg-menu");
                          },1000)
                        }}
                      >
                        Ok
                      </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-backdrop fade show"></div>
                </>
              )}
            </div>
          </div>
          
          {/* Raise Query Modal */}
          <div className="col-xl-4">
            <div className="card-body">
          {showRaiseQueryModal && (
  <>
    <div className="modal fade show" style={{display: 'block'}} id="raiseQueryModal" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabIndex={-1}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title" id="exampleModalToggleLabel">Raise Query: Sent Back to Sponsor</h4>
            <button 
              type="button" 
              className="btn-close" 
              onClick={() => setShowRaiseQueryModal(false)}
              aria-label="Close" 
            />
          </div>
          <div className="modal-body">
            <p>Are you sure you want to raise query ?</p>
            <textarea
              className={`form-control w-100 ${comment.trim() === '' ? 'border-danger' : ''}`}
              style={{ fontSize: '1.25rem' }}
              rows={3}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Enter your remarks here. *"
              required
            />
            {comment.trim() === '' && (
              <small className="text-danger">* Remarks are required</small>
            )}
          </div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-outline-secondary me-3" 
              onClick={() => {
                setShowRaiseQueryModal(false);
                setComment("");
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-info"
              onClick={handleRaiseQuery}
            >Yes, Sent back to Sponsor</button>
          </div>
        </div>
      </div>
    </div>
    <div className="modal-backdrop fade show"></div>
  </>
            )}

            {showRaiseQuerySuccessModal && (
              <>
                <div className="modal fade show" style={{display: 'block'}} id="raiseQueryModal2" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2" tabIndex={-1}>
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h4 className="modal-title" id="exampleModalToggleLabel2">
                          <i className="feather feather-check-circle text-success me-2"></i>
                          Query has been raised
                        </h4>
                        <button 
                          type="button" 
                          className="btn-close" 
                          onClick={() => setShowRaiseQuerySuccessModal(false)}
                          aria-label="Close" 
                        />
                      </div>
                      <div className="modal-body">
                        Application successfully sent back to sponsor
                      </div>
                      <div className="modal-footer">
                        <button 
                          type="button" 
                          className="btn btn-info me-3 w-100" 
                          onClick={() => {
                            setShowRaiseQuerySuccessModal(false);
                            setTimeout(()=>{
                              navigate("/marketing-board-reg-menu");
                            },1500)
                          }}
                        >
                          Ok
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-backdrop fade show"></div>
              </>
            )}
            </div>
          </div>
          
          {/* Reject Modal */}
          <div className="col-xl-4">
            <div className="card-body">
              {showRejectModal && (
                <>
                
                  <div className={`modal fade show`} style={{display: 'block'}} id="rejectModal" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabIndex={-1}>
                    {uploadLoading && (
                    <div className="position-fixed z-3 top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{background: "rgba(0,0,0,0.3)", zIndex: 1050}}>
                      <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
                        <div className="spinner-border text-primary mb-3" role="status">
                          <span className="visually-hidden">Uploading...</span>
                        </div>
                        <div className="fw-bold">Uploading, please wait...</div>
                      </div>
                    </div>
                  )}
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h4 className="modal-title" id="exampleModalToggleLabel">Application Rejection</h4>
                          <button 
                            type="button" 
                            className="btn-close" 
                            onClick={() => setShowRejectModal(false)}
                            aria-label="Close" 
                          />
                        </div>
                        <div className="modal-body">
                          <p>Are you sure you want to reject this application ?</p>
                          <input type="file"
                           className="form-control w-75 border border-dark mb-2"
                           name="rejectionFile"
                           onChange={(e)=> handleFileChange(e, "rejectionFile")}
                           />
                          {newlyUploaded.rejectionFile && (
                            <p className="fs-15 mt-2 opacity-75 text-center">Uploaded : {newlyUploaded.rejectionFile}</p>
                          )}
                          <p>Upload File (optional)</p>
                          <textarea
                            className={`form-control w-100 ${comment.trim() === '' ? 'border-danger' : ''}`}
                            style={{ fontSize: '1.25rem' }}
                            rows={3}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="Enter your remarks here. *"
                            required
                          />
                          {comment.trim() === '' && (
                            <small className="text-danger">* Remarks are required</small>
                          )}
                        </div>
                        <div className="modal-footer">
                          <button 
                            type="button" 
                            className="btn btn-outline-secondary me-3" 
                            onClick={() => {
                              setShowRejectModal(false);
                              setComment("");
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-info"
                            onClick={handleReject}
                          >Yes, Reject Application</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-backdrop fade show"></div>
                </>
                )}

                {showRejectSuccessModal && (
                  <>
                    <div className="modal fade show" style={{display: 'block'}} id="rejectModal2" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2" tabIndex={-1}>
                      <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h4 className="modal-title" id="exampleModalToggleLabel2">
                              <i className="feather feather-check-circle text-success me-2"></i>
                              Application Rejected
                            </h4>
                            <button 
                              type="button" 
                              className="btn-close" 
                              onClick={() => setShowRejectSuccessModal(false)}
                              aria-label="Close" 
                            />
                          </div>
                          <div className="modal-body">
                            Application has been rejected and status sent to the sponsor
                          </div>
                          <div className="modal-footer">
                            <button 
                              type="button" 
                              className="btn btn-info me-3 w-100" 
                              onClick={() => {
                                setShowRejectSuccessModal(false);
                                setTimeout(()=>{
                                  navigate("/marketing-board-reg-menu");
                                },1500)
                              }}
                            >
                              Ok
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-backdrop fade show"></div>
                  </>
                )}
            </div>
          </div>
        </>
      )}
      {/* Download Button */}
     {roleIdentifier === "SPO" && (
       <div className="d-flex justify-content-center mb-4 download-button-container">
        <button 
          onClick={handleDownloadFormL}
          className="btn btn-success px-5"
        >
          <i className="feather feather-download me-2"></i>
          Download Certificate
        </button>
      </div>
    )}
          <DocView key={documentUpdateTrigger} />

    </div>
  );
};

export default MDFormL;